export default __webpack_public_path__ + "static/cut-382b83f3447b5d69dbd36d0280671759.mp3";